import { baseApi } from "api/BaseApi";

import { PcmNumberPayload, PcmNumberReturn } from "./pcm.types";

const PCM_BASE_QUERY = "/pcm";

const pcmApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPcmNumber: build.query<PcmNumberReturn, PcmNumberPayload>({
      query: (payload) => {
        return {
          url: `${PCM_BASE_QUERY}/get_pcm_number/`,
          params: payload,
        };
      },
    }),
  }),
});

export const { useGetPcmNumberQuery, useLazyGetPcmNumberQuery } = pcmApi;
